import { Typography } from '@material-ui/core';
import React from 'react';
import data from '../../../utils/dbSchema';
import Layout from '../../Layout';
import { Box } from '../../UI';
import images from '../../UI/images';
import ActionButtons from './ActionButtons';
import Floorplan from './Floorplan';
import ImageCarousel from './ImageCarousel';
import Map from './Map';
import Status from './Status';
import StatusTable from './StatusTable';
import TenantTable from './TenantTable';
import PageTitle from '../../Layout/PageTitle'
import NavigateBack from '../../UI/NavigateBack';
import SummaryTable from './SummaryTable';

export default function Dashboard({ match }) {
	const { path } = match;
	const propertyData = data.properties.find(property => {
		return match.params.propertyId === property.id;
	});
	const { digitalId } = propertyData.sell;
	return (
		<Layout path={path}>
			<Box p="30px">
				<Box width="100%" height="100%">
					<PageTitle 
						title={!!propertyData ? `${propertyData.id}` : 'New Asset'} 
						subtitle={!!propertyData ? `${propertyData.sell.address}` : ''} 
						action={<NavigateBack slug={`/my-portfolio`} />}
					>
						<Status data={propertyData} />
					</PageTitle>
					<TenantTable data={propertyData} />
					<Box display="flex" flexDirection="row" pt="15px">
						<Box width="33.33%" pr='7.5px'>
							{digitalId > 99 && <StatusTable data={propertyData} />}
							<SummaryTable data={propertyData} />
						</Box>
						<Box width='33.33%' px='7.5px'>
							<Map data={propertyData} />
							<Floorplan active={!!propertyData && propertyData.sell.digitalId === 100} />
						</Box>
						<Box width='33.33%' pl="7.5px">
							<ImageCarousel
								images={
									!!propertyData && propertyData.sell.digitalId === 100 ? images[propertyData.index] : []
								}
							/>
							<ActionButtons data={propertyData} />
						</Box>
					</Box>
				</Box>
			</Box>
		</Layout>
	);
}
